<template>
  <div id="app">
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
  const Footer = () => import('./components/Footer.vue')
  
  export default {
    name: 'app',
    components: {
      'Footer': Footer,
      // 'Header': Header,
    }
  }
</script>

<style lang="scss">
/* // Import custom SASS variable overrides, or alternatively
// define your variable overrides here instead */
@import 'scss/style.scss';

:root {
  --primary:      $primary;
  --secondary:    $secondary;
  --success:      $success;
  --info:         $info;
  --warning:      $warning;
  --danger:       $danger;
  --light:        $light;
  --dark:         $dark;
}

</style>
